import { useSite } from "@inrange/building-manager-api-client";
import { SitePvReport } from "@inrange/theme-components/site";
import { useParams } from "react-router-dom";
import Loading from "../Loading";
import { inverterRatedOutputPowerTotalKwpAc } from "./siteSections/utils";

const SitePvReportPage = () => {
  const { siteId } = useParams<{ siteId: string }>();
  const { fetchSite, fetchSiteValues, LOSS_FACTORS_BY_KEY } = useSite({
    siteId,
    app: "admin",
  });

  if (!fetchSite.isLoading && fetchSite.isError) {
    return <div>Error loading the site.</div>;
  }

  if (!fetchSiteValues.isLoading && fetchSiteValues.isError) {
    return <div>Error loading the site values.</div>;
  }

  if (
    fetchSite.isLoading ||
    !fetchSite.data?.site ||
    fetchSiteValues.isLoading ||
    !fetchSiteValues.data
  ) {
    return <Loading label="Loading site data..." />;
  }

  const site = fetchSite.data.site;
  const pvPanels = fetchSiteValues.data.options.pvPanels;
  const pvInvertersSpec = fetchSiteValues.data.options.pvInverters;
  const pvPanel = pvPanels[site.pvPanelName];

  const pvInverters = site.totalInverters.map((installed) => ({
    name: installed.name,
    manufacturer: pvInvertersSpec[installed.name].manufacturer,
    model: pvInvertersSpec[installed.name].model,
    ratedAcOutputPower: pvInvertersSpec[installed.name].ratedAcOutputPower,
    count:
      typeof installed.count === "string"
        ? parseInt(installed.count)
        : installed.count,
  }));

  const inverterTotalPowerKwAc = inverterRatedOutputPowerTotalKwpAc(
    pvInvertersSpec,
    site.totalInverters
  );

  const lossFactorLabels: Record<string, string> = {};
  for (const [key, value] of Object.entries(LOSS_FACTORS_BY_KEY)) {
    lossFactorLabels[key] = value.label;
  }

  return (
    <SitePvReport
      site={site}
      pvPanel={pvPanel}
      pvInverters={pvInverters}
      inverterTotalPowerKwAc={inverterTotalPowerKwAc}
      lossFactorLabels={lossFactorLabels}
    />
  );
};

export default SitePvReportPage;
